import React from 'react';

function Date({ size, strokeWidth = 1.3, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      {...otherProps}
    >
      <rect x="3.65" y="4.54062" width="16.7" height="13.8111" rx="1.35" />
      <path d="M3.90039 8.33594H20.1004" />
      <path d="M6.59961 11.8906H17.3996" />
      <path d="M6.59961 14.5547H13.7996" />
      <path d="M7.5 4V6.66667" />
      <path d="M16.5 4V6.66667" />
    </svg>
  );
}

export default Date;
